import { makeStyles } from '@material-ui/core/styles'
import { COLORS, FONTS } from '../../../constants'

export const styles = makeStyles(theme => ({
  row: {
    marginBottom: 16,
  },
  rowInner: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 10,
    width: '100%',
  },
  platformSelect: {
    minWidth: 72,
    width: 72,
    flexShrink: 0,
    ['& .MuiOutlinedInput-root']: {
      height: 48,
      borderRadius: 8,
      backgroundColor: COLORS.white,
    },
    ['& .MuiOutlinedInput-notchedOutline']: {
      borderColor: COLORS.ashGrey,
    },
    ['& .MuiSelect-root']: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '8px 28px 8px 12px',
    },
    ['& .MuiSelect-icon']: {
      color: COLORS.black,
      right: 6,
    },
  },
  selectValue: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  platformIcon: {
    width: 22,
    height: 22,
    objectFit: 'contain',
    color: COLORS.black,
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 40,
  },
  input: {
    flex: 1,
    minWidth: 0,
    border: `1px solid ${COLORS.ashGrey}`,
    borderRadius: 8,
    background: COLORS.white,
    padding: '12px 14px',
    fontSize: 14,
    fontFamily: FONTS.Graphik.GraphikLight,
    outline: 'none',
    height: 48,
    boxSizing: 'border-box',
    ['&:focus']: {
      borderColor: theme.palette.primary.main,
    },
    ['&::placeholder']: {
      color: COLORS.lightGrey,
    },
  },
  deleteButton: {
    width: 48,
    minWidth: 48,
    height: 48,
    flexShrink: 0,
    border: `1px solid ${COLORS.ashGrey}`,
    borderRadius: 8,
    background: COLORS.white,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    outline: 'none',
    color: COLORS.black,
    ['&:hover']: {
      borderColor: COLORS.black,
    },
  },
  fieldError: {
    color: COLORS.dangerRed,
    fontSize: 12,
    margin: '6px 0 0',
    fontFamily: FONTS.Graphik.GraphikLight,
  },
}))
